import script from "./WapAboutView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapAboutView.vue?vue&type=script&lang=ts&setup=true"

import "./WapAboutView.vue?vue&type=style&index=0&id=3ac11fea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac11fea"]])

export default __exports__